<app-page-header [breadcrumbs]="breadcrumbs"></app-page-header>

<div class="block">
    <div class="container">
        <div class="document">
            <div class="document__header">
                <h1 class="document__title">{{title}}</h1>
                <div class="document__subtitle">{{subtitle}}</div>
            </div>
            <div class="document__content typography" [innerHTML]="text">
            </div>
        </div>
    </div>
</div>
